module.exports = __webpack_public_path__ + "static/flaming_fist_mtg_clb-2bb35790a1e34079bb25370b3aaad02a.jpg";